import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";

const OrderFilter = () => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [orderId, setOrderId] = useState("");
  const status = [
    { value: "pending", label: "قيد الانتظار" },
    { value: "accepted", label: "مقبولة" },
  ];
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    const idParam = params.get("orderId");
    if (statusParam) {
      setSelectedStatus(statusParam);
    } else {
      setSelectedStatus("");
    }
    if (idParam) {
      setOrderId(idParam);
    } else {
      setOrderId("");
    }
  }, [location.search]);

  const handleFilter = (e) => {
    const newStatus = e.target.value;
    const params = new URLSearchParams(location.search);

    if (newStatus === "") {
      params.delete("status");
    } else {
      params.set("status", newStatus);
    }

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const handleIdFilter = (e) => {
    const newId = e.target.value;
    const params = new URLSearchParams(location.search);
    if (newId === "") {
      params.delete("orderId");
    } else {
      params.set("orderId", newId);
    }
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };
  return (
    <div className="flex items-center gap-2">
      <select
        className="rounded-md bg-blueSecondary py-1 px-3 text-white"
        onChange={handleFilter}
        value={selectedStatus}
        name="status"
      >
        <option value="">الكل</option>
        {status.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      <div className="relative flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 px-3 py-1 dark:border-navy-700 dark:bg-navy-800">
        <input
          className="w-full bg-gray-100 focus:outline-none dark:bg-navy-800"
          type="search"
          placeholder="رقم الطلب"
          value={orderId}
          onChange={handleIdFilter}
        />
        <IoIosSearch />
      </div>
    </div>
  );
};

export default OrderFilter;
